<template>
	<div>
		<div class="c-controls__group">
			<label class="c-controls__label">{{ scenarioTitle }}</label>
			<select v-model="scenario" @change="chooseScenario">
				<option v-for="scenario in scenarios" :key="scenario.title" :value="scenario.title">
					{{ scenario.title }}
				</option>
			</select>
<!--			<button class="button" @click="shuffleScenarios">Shuffle</button>-->
		</div>
	</div>
</template>

<script>
import BaseSlide from './BaseSlide';
import {catchUpPromise} from "../../../components/state-calculator";

export default {
	name: 'ScenarioPreviewSlide',
	mixins: [BaseSlide],
	methods: {
		chooseScenario() {
			this.$emit('subcommand', 'set-variable', {
				name: 'scenario',
				value: this.scenario,
			});
		},
		shuffleScenarios(){
			function shuffleArray(array) {
				for (let i = array.length - 1; i > 0; i--) {
					const j = Math.floor(Math.random() * (i + 1));
					[array[i], array[j]] = [array[j], array[i]];
				}
			}

			const scenarios = this.slide?.settings?.scenarios || [];

			if (this.shuffle) {
				shuffleArray(scenarios);
			}

			const result = scenarios.filter((x, index) => index < this.amount); //take two

			this.$emit('subcommand', 'set-variable', {
				name: 'scenarios',
				value: result,
			});

		}
	},
	data() {
		return {
			scenario: this.$actions.getVariable('scenario'),
		};
	},
	watch: {
		globalScenario(){
			this.scenario = this.globalScenario;
		},
	},

	mounted() {
		catchUpPromise.then(() => {
			console.log('checking for scenarios', this.scenarios);
			if(!this.scenarios || this.scenarios.length < 1){

				this.shuffleScenarios();
			}
		});
	},
	computed: {
		shuffle() {
			// Default is shuffle
			if (typeof this.slide.settings.shuffle_scenarios == 'undefined' || this.slide.settings.shuffle_scenarios) {
				return true;
			}

			return false;
		},
		scenarioTitle() {
			return this.slide?.settings?.scenario_title;
		},
		amount() {
			if (this.slide?.settings?.scenario_amount) {
				return this.slide.settings.scenario_amount;
			}

			return 2;
		},
		scenarios() {
			return this.$actions.getVariable('scenarios', []);
		},
		globalScenario() {
			return this.$actions.getVariable('scenario', '');
		},
	},
};
</script>

<style></style>
